import { ACTIONS } from '../constants/enum'
import { DownloadAction } from '../constants/interface'

const DOWNLOAD_ZIP = (state = { data: '', error: '' }, action: DownloadAction) => {
  switch (action.type) {
    case ACTIONS.DOWNLOAD_ZIP:
      return {
        error: '',
        data: action.payload
      }
    case ACTIONS.CLEAN_DOWNLOAD:
      return {
        data: ''
      }
    case ACTIONS.ERROR_REQUEST_DOWNLOAD:
      return {
        data: ''
      }
    default:
      return state
  }
}

export default DOWNLOAD_ZIP
